import styled from "styled-components";

export const Icon = styled.div`
  width: 40px;
`;
